import React, { useState, useEffect } from 'react';
import { Bars3Icon, XMarkIcon, MagnifyingGlassIcon, ShoppingBagIcon, UserIcon } from '@heroicons/react/24/outline';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navigation = [
    { name: 'Shop', href: '#collections' },
    { name: 'New', href: '#new' },
    { name: 'About', href: '#about' },
    { name: 'Contact', href: '#contact' },
  ];

  // Calculate header animation values
  const isScrolled = scrollY > 100;
  const headerOpacity = Math.min(1, scrollY / 200);
  const logoOpacity = Math.min(1, Math.max(0, (scrollY - 150) / 150));
  const logoScale = Math.min(1, Math.max(0.8, (scrollY - 100) / 200));

  return (
    <header 
      className="fixed w-full top-0 z-50 transition-all duration-300"
      style={{
        backgroundColor: `rgba(255, 255, 255, ${headerOpacity * 0.95})`,
        backdropFilter: isScrolled ? 'blur(12px)' : 'none',
      }}
    >
      <nav className="px-4">
        <div className="flex h-14 items-center justify-between">
          {/* Left Icons */}
          <div className="flex items-center space-x-4">
            <button className={`transition-colors duration-300 ${
              isScrolled ? 'text-gray-700' : 'text-white'
            }`}>
              <MagnifyingGlassIcon className="h-5 w-5" />
            </button>
            <button className={`transition-colors duration-300 ${
              isScrolled ? 'text-gray-700' : 'text-white'
            }`}>
              <UserIcon className="h-5 w-5" />
            </button>
          </div>

          {/* Center Logo - Animates in from hero */}
          <div 
            className="absolute left-1/2 transform -translate-x-1/2 transition-all duration-300 ease-out"
            style={{
              opacity: logoOpacity,
              transform: `translateX(-50%) scale(${logoScale}) translateY(${logoOpacity < 1 ? '8px' : '0px'})`,
            }}
          >
            <h1 className="text-lg font-serif font-bold tracking-[0.2em] text-gray-900">
              ELARA
            </h1>
          </div>

          {/* Right Icons */}
          <div className="flex items-center space-x-4">
            <button className={`transition-colors duration-300 relative ${
              isScrolled ? 'text-gray-700' : 'text-white'
            }`}>
              <ShoppingBagIcon className="h-5 w-5" />
              <span className="absolute -top-1 -right-1 bg-gold-500 text-white text-xs rounded-full h-4 w-4 flex items-center justify-center text-[10px]">
                0
              </span>
            </button>
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className={`transition-colors duration-300 ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              {isMenuOpen ? (
                <XMarkIcon className="h-5 w-5" />
              ) : (
                <Bars3Icon className="h-5 w-5" />
              )}
            </button>
          </div>
        </div>

        {/* Mobile Navigation Overlay */}
        {isMenuOpen && (
          <div className="fixed inset-0 top-14 bg-white z-40">
            <div className="p-6 space-y-6">
              {navigation.map((item) => (
                <a
                  key={item.name}
                  href={item.href}
                  className="block text-2xl font-light text-gray-900 hover:text-gold-600 transition-colors"
                  onClick={() => setIsMenuOpen(false)}
                >
                  {item.name}
                </a>
              ))}
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;